import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ERTEmergencyResponseService } from "../../services/emergency-response/emergency-response.service";
import { ERTEmergencyResponse } from "../../interfaces/emergencyresponse/emergencyresponse";
import { ERTUser } from "../../interfaces/ert-user/ert-user";
import { ERTUserService } from "../../services/ert-user/ert-user.service";
import { LoggedUserService } from "../../services/common/logged-user.service";
import { ILoggedUserData } from "../../interfaces/common/loggedUserData";
import { IFacilityData } from "../../interfaces/administration/facilityData";

@Component({
  selector: "app-ert-emergency-response-additionalinfo",
  templateUrl: "./ert-emergency-response-additionalinfo.component.html",
})
export class ErtEmergencyResponseAdditionalinfoComponent implements OnInit {
  ertUsers: ERTUser[] = [];
  incidentCommanderFullName: string;
  incidentCommander: ERTUser;
  addedEmergencyResponse: ERTEmergencyResponse;

  currentUser: ILoggedUserData;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ertUserService: ERTUserService,
    public ertEmergencyResponseService: ERTEmergencyResponseService,
    private loggedUserService: LoggedUserService
  ) {}

  ngOnInit() {
    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      this.currentUser = user;
      const facilityId = Number(user.facilityId) || 1; 
      this.ertUserService.getAllERTUsers(facilityId).subscribe((data) => {
        this.ertUsers = data;
      });
    });
  }

  addEmergencyResponse() {
    this.incidentCommanderFullName =
      this.ertEmergencyResponseService.addEmergencyResponseForm.get("incidentCommander").value;

    this.ertEmergencyResponseService.setERTEmergencyResponse(<ERTEmergencyResponse>{
      dateTimeIncidentOccured:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get(
          "dateAndTimeIncidentOccurred"
        ).value,
      dateTimeIncidentCleared:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get(
          "dateAndTimeIncidentCleared"
        ).value,
      incidentCommanderId: this.getIncidentCommanderId(
        this.incidentCommanderFullName
      ),
      incidentCommander: this.incidentCommander,
      description:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get(
          "description"
        ).value,
      otherDescription:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get(
          "otherDescription"
        ).value,
      isFire:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get("fire")
          .value ?? false,
      isRescue:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get("rescue")
          .value ?? false,
      isHazmat:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get("hazmat")
          .value ?? false,
      isLeak:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get("leak")
          .value ?? false,
      isMedical:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get("medical")
          .value ?? false,
      isOdor:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get("odor")
          .value ?? false,
      isOther:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get("other")
          .value ?? false,
      isERTCallOut:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get(
          "ertCallOut"
        ).value ?? false,
      reasonForResponse:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get(
          "reasonForResponse"
        ).value,
      tactics:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get("tactics")
          .value,
      results:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get("results")
          .value,
      responders:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get(
          "responders"
        ).value,
      comments:
        this.ertEmergencyResponseService.addEmergencyResponseForm.get(
          "comments"
        ).value,
      facilityId: Number(this.currentUser.facilityId) || 1,
      facility: <IFacilityData>{
        id: Number(this.currentUser.facilityId) || 1,
        name: this.currentUser.facilityName,
      },
      createdById: this.currentUser.id,
    });

    this.ertEmergencyResponseService.addERTEmergencyResponse().subscribe({
      next: (data) => {
        this.addedEmergencyResponse = data as ERTEmergencyResponse;
        if (this.addedEmergencyResponse.isMedical) {
          this.router.navigate(
            ["/ert-emergency-response/emergency-response-addmrs-create"],
            {
              queryParams: {
                emergencyResponseId: this.addedEmergencyResponse.id,
              },
            }
          );
        } else {
          this.router.navigate(["/ert-emergency-response/"]);
        }
      },
      error: (error) => {},
    });
  }

  getIncidentCommanderId(incidentCommander: string): number {
    const user = this.ertUsers.find((u) => u.fullName === incidentCommander);
    this.incidentCommander = user;
    return user.id;
  }
}
